import { render, staticRenderFns } from "./vocation.vue?vue&type=template&id=bdee5ab2&"
import script from "./vocation.vue?vue&type=script&lang=js&"
export * from "./vocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports